import { render } from "./KarirView.vue?vue&type=template&id=7c8e904c"
import script from "./KarirView.vue?vue&type=script&lang=js"
export * from "./KarirView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__